import React, { Component } from 'react'
import { Button, message, Tooltip, Modal, Table } from "antd"
import BatchRecycle from "./batch-actions/BatchRecycleV2"
import ExportBatch from "./batch-actions/ExportBatch"
import ExportDetailError from "./batch-actions/ExportDetailError"
import ExportBatchCSV from "./batch-actions/ExportBatchCSV"
import BatchMerge from "./batch-actions/BatchMerge"
import ChangeStatusSewing from './batch-actions/ChangeStatusSewing'
import { getLocalData } from '../../../services/StorageServices'
import { parseJwt } from '../../../helpers/parseToken'
import { getUserPermissions } from '../../../services/AuthServices'
import ChangeStatusTransferred from "./batch-actions/ChangeStatusTransferred"
import { recycleBatchV2, recycleBatchDetails } from "../../../services/api/3dApi"
import ProcessingTime from "../../shared/ProcessingTime"
import StatusStyle from '../../shared/StatusStyle'
class BatchActions extends Component {
    state = {
        isOpen: false,
        hovering: false,
    }


    _handleChangeModal = isOpen => {
        this.setState({ isOpen })
    }

    _handleHovering = (isHover) => {
        this.setState({
            hovering: isHover
        })
    }

    // @FAC-24561: hai nút hệ màu (CMYK / Non-CMYK) chỉ khác nhau ở nhãn, màu nền và
    // cờ non_cmyk gửi lên API — mọi thứ còn lại (luật disable, lớp bọc Tooltip khi
    // đang xử lý) giống hệt nhau, nên gom về một chỗ thay vì nhân bản khối Button.
    _renderColorSystemButton = (variant, shared) => {
        const { label, color, nonCmyk } = variant
        const { isUnDisabledBtn, isReady, processingAt, errorMessage, mergeFileStatus, loading, onActionSendMerge } = shared
        const { hovering } = this.state

        const button = (
            <Button
                type="primary"
                icon="download"
                onClick={() => onActionSendMerge(true, '', nonCmyk)}
                className={`mr-3 mt-2 ${isReady === false ? 'btn-crossed cmyk' : ''}`}
                disabled={loading || !isUnDisabledBtn}
                style={{
                    backgroundColor: isUnDisabledBtn ? color : '#f5f5f5',
                    borderColor: isUnDisabledBtn ? color : '#d9d9d9',
                    color: isUnDisabledBtn ? '#ffffff' : '#00000040'
                }}
            >
                {label}
            </Button>
        )

        if (mergeFileStatus === "processing" && (!!processingAt || !!errorMessage)) {
            return (
                <Tooltip
                    placement='topLeft'
                    title={<ProcessingTime processingAt={processingAt} hovering={hovering} errorMessage={errorMessage} />}
                    onMouseEnter={() => this._handleHovering(true)}
                    onMouseLeave={() => this._handleHovering(false)}
                >
                    {button}
                </Tooltip>
            )
        }

        return button
    }

    render() {
        const { changeContent, showButton, batch, match, history, onShowHistory, status, refreshBatchInfo, isShowButtonPieceError, data, onActionSendMerge, loading } = this.props
        const { isOpen, hovering } = this.state
        const { merge_file_status, merge_file_job = {}, tags = [] } = batch
        const userToken = parseJwt(getLocalData('accessToken')) || {}
        const permissions = getUserPermissions()
        const {roles = []} = {...userToken}
        const isAdmin = roles.some(item => ['Super Admin', 'fac_admin'].includes(item.name))
        const isUnDisabledBtn = ["created", "done", "error"].includes(merge_file_status) 
        const { description, items, isReady } = Object.assign({}, data)
        const { processing_at, error_message } = Object.assign({}, merge_file_job)
        // @FAC-24561: hai nút hệ màu dùng chung một điều kiện hiển thị — admin và lô
        // không bị ép RGB. KHÔNG ẩn nút Non-CMYK theo need_convert_cmyk hay
        // meta.non_cmyk: người vận hành phải bấm lại được để retry job bị lỗi.
        const isColorSystemButtonVisible = isAdmin && !tags.includes('force_rgb')
        const isCmykCreator = (batch.user_create || '').toLowerCase().includes('cmyk')
        const shouldHideDownload = isColorSystemButtonVisible && isCmykCreator

        const colorSystemButtonProps = {
            isUnDisabledBtn, isReady, loading, onActionSendMerge,
            processingAt: processing_at,
            errorMessage: error_message,
            mergeFileStatus: merge_file_status,
        }

        const columns = [
            {
                title: 'Item',
                dataIndex: 'barcode',
                key: 'barcode',
            },
            {
                title: 'Type',
                dataIndex: 'type',
                key: 'type',
            },
            {
                title: 'Size',
                dataIndex: 'size',
                key: 'size',
            },
            {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
                render: (_, r) => {
                    const { status } = r
                    return <StatusStyle status={status} />
                }
            },
            {
                title: 'Job',
                dataIndex: 'job',
                key: 'job',
                render: (_, r) => {
                    const { jobs = [] } = r
                    return !!jobs.length ?
                        <Tooltip title={jobs.join(", ")}>
                            <StatusStyle status={jobs[jobs.length - 1]} />
                        </Tooltip> : ''
                }
            },
        ]

        return (
            <div className='d-flex flex-wrap align-items-center'>
                {/* {
                    (isAdmin && _.get(batch, 'status') === "pending") &&
                    <ChangeStatusTransferred batch={batch}  refreshBatchInfo={refreshBatchInfo}/>
                }

                {
                    (isAdmin && _.get(batch, 'status') === "pending") &&
                    <ChangeStatusSewing batch={batch}  refreshBatchInfo={refreshBatchInfo}/>
                } */}
                {
                    isAdmin && !!description && !isReady &&
                    <Tooltip title={description}>
                        <i
                            className="fa fa-exclamation-triangle mr-3 mt-2 cursor-pointer"
                            style={{
                                fontSize: 24,
                                color: '#d7c308'
                            }}
                            onClick={() => this._handleChangeModal(true)}
                        />
                    </Tooltip>
                }
                <Modal
                    visible={isOpen}
                    onCancel={() => this._handleChangeModal(false)}
                    footer={null}
                    width={700}
                >
                    <Table
                        dataSource={items}
                        columns={columns}
                        pagination={{ defaultPageSize: 10, showSizeChanger: true, pageSizeOptions: ['10', '20', '30'] }}
                        style={{ width: '100%', maxHeight: 500, overflowY: 'auto', overflowX: 'hidden' }}
                    />
                </Modal>
                {
                    !tags.includes('force_cmyk') && !shouldHideDownload &&
                    <BatchMerge
                        loading={loading}
                        id={batch._id}
                        refreshBatchInfo={refreshBatchInfo}
                        onActionSendMerge={onActionSendMerge}
                        disabled={!isUnDisabledBtn}
                        className="btn-crossed download-file"
                        isReady={isReady}
                        processingAt={processing_at}
                        errorMessage={error_message}
                        onHovering={this._handleHovering}
                        hovering={hovering}
                        mergeFileStatus={merge_file_status}
                    />
                }
                {isColorSystemButtonVisible && this._renderColorSystemButton(
                    { label: 'CMYK', color: '#722ed1', nonCmyk: false },
                    colorSystemButtonProps
                )}
                {isColorSystemButtonVisible && this._renderColorSystemButton(
                    { label: 'Non-CMYK', color: '#dc3644', nonCmyk: true },
                    colorSystemButtonProps
                )}
                <Button icon={!changeContent ? 'exclamation-circle' : 'info-circle'}
                    type={changeContent ? 'primary' : ''}
                    className='mr-3 mt-2'
                    onClick={onShowHistory}>{!changeContent ? 'Xem lịch sử' : 'Chi tiết lô'}</Button>
                <ExportBatchCSV
                    changeContent={changeContent}
                    match={match}
                    history={history}
                    status={status}
                />
                {
                    permissions.hasOwnProperty('fac_developer') &&
                    <ExportBatch
                        changeContent={changeContent}
                        match={match}
                        history={history}
                        status={status}
                    />
                }
                {/* <ExportDetailError
                    changeContent={changeContent}
                    match={match}
                /> */}
                {
                    showButton && batch.hasOwnProperty('_id') &&
                    <BatchRecycle
                        level={batch.level_number !== undefined && batch.level_number.toString()}
                        partner={batch.partner}
                        user={batch.user_create}
                        id={match.params.id}
                        history={history}
                        changeContent={changeContent}
                        recycleBatchV2={recycleBatchV2}
                        title="Tái tạo lô"
                    />
                }
                {
                    showButton && batch.hasOwnProperty('_id') && isShowButtonPieceError &&
                    <BatchRecycle
                        level={batch.level_number !== undefined && batch.level_number.toString()}
                        partner={batch.partner}
                        user={batch.user_create}
                        id={match.params.id}
                        history={history}
                        changeContent={changeContent}
                        recycleBatchV2={recycleBatchDetails}
                        title="Tái tạo lô bù chi tiết"
                    />
                }
            </div>
        )
    }
}

export default BatchActions